export default "__VITE_ASSET__ZLNvBg4a__"